import 'whatwg-fetch' // fetch polyfill for IE
require('./auth')
require('./basket')
require('./booking-form')
require('./auto-refresh')



// WEBPACK FOOTER //
// ./resources/assets/js/app.js